export const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';
export const DATETIME_FORMAT_DD_MM = 'DD.MM HH:mm:ss';
export const DATETIME_FORMAT_DD_MM_HH_MM = 'DD.MM HH:mm';

export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_FORMAT_MM_YYYY = 'MM.YYYY';

export const DATE_FORMAT_DD_MM = 'DD.MM';
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_FORMAT_HH_MM = 'HH:mm';

export const SIZE_BIG = 'big';
export const SIZE_MEDIUM = 'medium';
export const SIZE_SMALL = 'small';

export const TYPE_MENU_ITEM_HEADER = 'HEADER';
export const TYPE_MENU_ITEM_MENU = 'MENU';
export const TYPE_MENU_ITEM_LINK = 'LINK';
export const TYPE_MENU_ITEM_DIVIDER = 'DIVIDER';

export const TYPE_POSITIVE = 'positive';
export const TYPE_NEGATIVE = 'negative';
export const TYPE_INFORMATION = 'information';
export const TYPE_WARNING = 'warning';
export const TYPE_DISABLED = 'disabled';

export const TYPE_DEFROST = 'DEFROST';
export const TYPE_LIGHT = 'LIGHT';
export const TYPE_SAVE_ENERGY = 'SAVE_ENERGY';
export const TYPE_SETPOINT = 'SET_POINT';
export const TYPE_TURN_ON_OFF = 'TURN_ON_OFF';
export const TYPE_GLASS_HEATER = 'GLASS_HEATER';
export const TYPE_KNIFE_WIPER = 'KNIFE_WIPER';
export const TYPE_DOOR_HEATER = 'DOOR_HEATER';
export const TYPE_SUPERFROST = 'SUPERFROST';
export const TYPE_HUMIDITY = 'HUMIDITY';
export const TYPE_FLASHFREEZE = 'FLASHFREEZE';
export const TYPE_FLASHCOOL = 'FLASHCOOL';
export const TYPE_SETPOINT_P1 = 'SETPOINT_P1';
export const TYPE_SETPOINT_P2 = 'SETPOINT_P2';
export const TYPE_SETPOINT_T = 'SETPOINT_T';
export const TYPE_SETPOINT_H = 'SETPOINT_H';

export const TYPE_COMPRESSOR = 'COMPRESSOR';
export const TYPE_VENTILATOR = 'VENTILATOR';
export const TYPE_HEATER = 'HEATER';
export const TYPE_CYCLE = 'CYCLE';
export const TYPE_DIRECT = 'DIRECT';
